import React, { useState } from "react";
import { connect } from "react-redux";
import Cookies from "js-cookie";
import { AsyncKey } from "constants/index";
import LanguageSelectorModal from './LanguageSelectorModal';
import './index.css';

const LanguageButton = () => {
  const [showLangModal, setShowLangModal] = useState(false);
  const lang = Cookies.get(AsyncKey.languageKey) || "vi";
  const setLang = async (selectedLang:string) => {
    await Cookies.set(AsyncKey.languageKey, selectedLang);
    window.location.reload();
  };
  const toggleLangSelectorModal = () => {
    setShowLangModal(!showLangModal);
  };
  return (
    <div
      className="app-navigation-language btn btn-secondary"
      onClick={toggleLangSelectorModal}
    >
      <span>{lang}</span>
      {showLangModal &&
        <LanguageSelectorModal
          isShow={showLangModal}
          onLangSelected={(selectedLang:string) => setLang(selectedLang)}
          onModalToggle={(toggleStatus:boolean) => setShowLangModal(toggleStatus)}
        />
      }
    </div>
  );
};

export default LanguageButton;
